export default function About() {
  return (
    <section id="about" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[860px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 md:h-8 rounded-full bg-secondary-500"></div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            关于我们
          </h2>
        </div>

        <div className="rounded-xl bg-background-100 border border-background-200/70 p-6 md:p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-500 flex items-center justify-center flex-shrink-0">
              <span className="text-background-50 font-bold text-xl md:text-2xl whitespace-nowrap">17</span>
            </div>
            <div>
              <h3 className="font-heading font-bold text-lg md:text-xl text-foreground-900">17吃瓜网</h3>
              <p className="text-sm text-foreground-500">17吃瓜爆料 · 17吃瓜黑料 · 17黑料吃瓜</p>
            </div>
          </div>

          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            17吃瓜网成立于2024年，是国内领先的网红黑料与明星爆料聚合平台。我们致力于为吃瓜群众提供最及时、最全面、最真实的娱乐圈黑料资讯。覆盖17吃瓜黑料网、17黑料吃瓜、内幕吃瓜等热门领域，每日更新超百条独家爆料与深度解读。
          </p>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-4">
            我们拥有一支专业的采编团队与遍布全国的线人网络，确保每一条17c吃瓜黑料爆料都经过严格的事实核查。平台坚持"还原事实、传播真料、拒绝谣言"的运营理念，在娱乐圈资讯领域建立了独特的公信力与影响力。同时，我们倡导理性讨论、文明吃瓜，为用户营造健康积极的吃瓜爆料交流环境。
          </p>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
            无论是顶流明星的私生活曝光、网红圈的内幕纷争，还是综艺节目幕后潜规则、选秀造假黑幕——17吃瓜网都在第一线为你揭开真相。吃瓜第一线，爆料不隔夜。
          </p>
        </div>
      </div>
    </section>
  );
}